export const dateRangeShutdownsEnum = {
  CREATE: 'create',
  START: 'start_time',
  COMPLETION_PLANNED: 'completion_planned_date',
  COMPLETION_ACTUAL: 'completion_actualdate',
};
